import { proxy } from '@/utils'

import render from './render'

export default {
  name: 'RoutesFormTitle',

  mixins: [ proxy({ type: 'object' }) ],

  props: {
    serviceName: {
      type: String,
      required: true
    },

    showSwitch: {
      type: Boolean,
      default: true
    },

    disabled: Boolean
  },

  computed: {
    gridTemplateColumns() {
      const result = [ '1fr' ]
      if (this.showSwitch) {
        result.push('auto')
      }

      return result.join(' ')
    }
  },

  render
}
